const addTextToFormInput = (selector, text) => {
    const input = document.querySelector(selector);
    if (!input)
        return false;
    input.value = text;
};
export default addTextToFormInput;
